/**
 * Formats LATRA/CeTS insists on. The backend enforces the same rules
 * (common.validators.ts); checking here too lets the admin fix a value inline
 * instead of hitting a 400 on save.
 */

export function normalizePlate(value: string): string {
  return value.replace(/\s+/g, "").toUpperCase();
}

export function plateError(value: string): string | null {
  if (!value.trim()) return null;
  return /^(T|MC)\d{3}[A-Z]{3}$/.test(normalizePlate(value))
    ? null
    : "Must look like T123ABC (car) or MC123ABC (motorcycle/bajaji)";
}

export function normalizeLicense(value: string): string {
  return value.replace(/\s+/g, "");
}

export function licenseError(value: string): string | null {
  if (!value.trim()) return null;
  return /^\d{10}$/.test(normalizeLicense(value))
    ? null
    : "Must be exactly 10 digits";
}
